<template>
    <span class="fill-height wi-100">
        <v-row v-if="type === 'norightpanel'" class="d-flex fill-height no-gutters page-template no-right-panel">
            <v-col class="d-none d-md-flex flex-column flex-grow-0 justify-center fill-height menu-container">
                <navigation-menu></navigation-menu>
            </v-col>
            <v-col class="d-flex flex-column flex-grow-0 central-panel">
                <slot name="toolbar"></slot>
                <slot name="main-panel-content"></slot>
            </v-col>
        </v-row>
        <v-row v-if="type === 'rightpanel'" class="d-flex fill-height no-gutters page-template">
            <v-col class="d-none d-md-flex flex-column justify-center fill-height menu-container">
                <navigation-menu></navigation-menu>
            </v-col>
            <v-col class="d-flex flex-column fill-height flex-grow-1">
                <slot name="toolbar"></slot>
                <v-row class="d-flex fill-height no-gutters">
                    <v-col class="d-flex flex-column central-panel">
                        <slot name="central-panel-content"></slot>
                    </v-col>
                    <v-col class="d-none d-md-flex flex-column right-panel fill-height flex-grow-1">
                        <div class="px-6 fill-height">
                            <slot name="right-panel-content"></slot>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </span>
</template>

<script>
// @ is an alias to /src

import navigationMenu from '@/components/NavigationMenu.vue'
export default {
  name: 'page-template',
  components: { navigationMenu },
  props: ['type'],
  data () {
      return {
      }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss">
    .page-template{
        .menu-container{
            width: 20vw;
            flex-basis: 20vw;
            flex-grow: 0;
            flex-shrink: 0;
        }
        .central-panel{
            width : 75%;
            flex-basis: 75%;
            flex-grow: 0;
            flex-shrink: 0;
            @include phone{
                width: 100%;
                flex-basis: 100%;
            }
            >:first-child{
                padding-top: 8rem;
                @include phone{
                    padding-top: 0;
                }
            }
        }
        .right-panel >:first-child{
            background: #F9FAFE;
            padding-top: 8rem;
        }
        // &.no-right-panel{
        //     .central-panel >:first-child{
        //         width: 80vw;
        //     }
        // }
    }
</style>
